import $ from 'jquery';

$("body").on('keyup', ".select2,.select2-dropdown", function (e) {
    var KEYS = { UP: 38, DOWN: 40 };
    var $sel2 = $(this).closest(".select2");

    if ($sel2.length == 0) {
        $sel2 = $(".select2.select2-container--open");
    }

    var $sel = $sel2.data("element")
    if ($sel && $sel.length) {
        var newValue

        if (e.keyCode === KEYS.DOWN && !e.altKey) {
            newValue = $sel.find('option:selected').nextAll(":enabled").first().val();
        } else if (e.keyCode === KEYS.UP) {
            newValue = $sel.find('option:selected').prevAll(":enabled").first().val();
        }

        if (newValue != undefined) {
            $sel.val(newValue);
            $sel.trigger('change');
        }
    }

});

const updateSelect2AriaLabels = (group) => {
    let itemSelector = null;

    if (group) {
        itemSelector = $(group).find('.select2-selection--single');
    } else {
        itemSelector = $('.select2-selection--single');
    }

    $(itemSelector).each(function () {
        var $this = $(this);
        var parentContainer = $this.parents('.select2-container');
        var bookingRoomContainer = $this.parents('.booking-table__row');

        if (parentContainer) {
            var previousLabel = $this.parents('.select2-container').siblings('label');
            var previousLabelText = previousLabel.text().trim();

            if (bookingRoomContainer.length > 0) {
                var bookingRoomNumberPrefix = bookingRoomContainer.find('.booking-table__room span').text().trim() + ' ';
                previousLabelText = bookingRoomNumberPrefix + previousLabelText.toLowerCase();
            }

            if (previousLabel) {
                $this.attr('aria-label', previousLabelText);

                parentContainer.find('.select2-selection__rendered').attr('aria-label', previousLabelText);
            }

            if (!previousLabel && parentContainer.parents('.availabilityLowerRow__selectRow')) {
                var availabilityContainer = parentContainer.parents('.availabilityLowerRow__selectRow');
                var relatedH2 = availabilityContainer.siblings('h2');
                if (relatedH2) {
                    $this.attr('aria-label', relatedH2.text());
                }
            }
        }
    });
}

$(document).ready(function () {
    setTimeout(function () {
        updateSelect2AriaLabels();
    }, 500);


    // Setup observer to look for new elements appearing
    const bookingListContainer = document.querySelector('.booking-menu-tabs__content-container .booking-table');
    if (bookingListContainer) {
        new MutationObserver((entries, observer) => {
            updateSelect2AriaLabels(bookingListContainer);
        }).observe(bookingListContainer, { attributes: false, childList: true, subtree: true});
    }
});